import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { ApiSecurityHeroSection } from "@/components/insights/api-security/ApiSecurityHeroSection";
import { ApiSecurityTakeaway } from "@/components/insights/api-security/ApiSecurityTakeaway";
import { ApiSecurityFounderQuote } from "@/components/insights/api-security/ApiSecurityFounderQuote";
import { ApiSecurityKeyFindings } from "@/components/insights/api-security/ApiSecurityKeyFindings";
import { ApiSecurityAuthentication } from "@/components/insights/api-security/ApiSecurityAuthentication";
import { ApiSecurityBestPractices } from "@/components/insights/api-security/ApiSecurityBestPractices";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const ApiSecurityBestPracticesPage = () => {
  return (
    <>
      <InsightEngagementTracker slug="api-security-best-practices" title="API Security Best Practices" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb category="Development" currentPage="API Security Best Practices" />
        <ApiSecurityHeroSection />
        <AnimatedSection delay={100} className="mt-10 sm:mt-12"><ApiSecurityTakeaway /></AnimatedSection>
        <AnimatedSection delay={50} className="mt-8 sm:mt-10"><ApiSecurityFounderQuote /></AnimatedSection>
        <div className="section-divider" />
        <AnimatedSection delay={0}><ApiSecurityKeyFindings /></AnimatedSection>
        <AnimatedSection delay={0}><ApiSecurityAuthentication /></AnimatedSection>
        <AnimatedSection delay={0}><ApiSecurityBestPractices /></AnimatedSection>
        <AnimatedSection delay={0}><InsightBenchmarks insightSlug="api-security-best-practices" /></AnimatedSection>
        <AnimatedSection delay={0}><InsightFAQSection insightSlug="api-security-best-practices" /></AnimatedSection>
        <AnimatedSection delay={0}><RelatedTools insightSlug="api-security-best-practices" /></AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default ApiSecurityBestPracticesPage;
